import { Typography } from 'antd';
import { Avatar, Select } from 'components/common';
import { SelectProps } from 'components/common/select/Select';
import OmiChanelChatSourceIcon from 'components/omni-channel-chat/OmiChanelChatSourceIcon';
import { useLazyOmniCustomers } from 'hooks';
import { useEffect, useState } from 'react';
import { FindAllCustomerDto } from 'types';
import { CHAT_SESSION_SOURCE } from 'utils';

type SelectCustomersProps = SelectProps & Omit<FindAllCustomerDto, 'keyword' | 'pageIndex' | 'pageSize'>;

const OmniChannelCustomerSelect = ({ ...props }: SelectCustomersProps) => {
  const [keyword, setKeyword] = useState('');

  const { data, handleLoadMore, hasMore, isLoading, fetchData, count } = useLazyOmniCustomers();

  const handleSearch = (val: string) => {
    fetchData({
      keyword: val
    });
  };

  useEffect(() => {
    fetchData({});
  }, []);

  return (
    <Select
      {...props}
      onLoadMore={handleLoadMore}
      loading={isLoading}
      hasMore={hasMore}
      showSearch
      filterOption={false}
      onSearch={handleSearch}
      options={
        data.map((itm) => ({
          ...itm,
          label: (
            <div className='flex h-10 items-center gap-2'>
              <div className='relative h-8 w-8'>
                <Avatar key={itm.customerId} size={32} src={itm.customerAvatar} name={itm.customerName} />
                <div className='absolute -bottom-0.5 -right-0.5 flex items-center justify-center'>
                  <OmiChanelChatSourceIcon size={16} source={itm.source as CHAT_SESSION_SOURCE} />
                </div>
              </div>
              <Typography.Text>{itm.customerName}</Typography.Text>
            </div>
          ),
          value: `${itm['customerId']}:${itm?.source ? `${itm?.pageId}` : ''}`,
          title: itm.customerName
        })) || []
      }
      labelRender={(item) => {
        return <span>{(item as any).title}</span>;
      }}
      onDropdownVisibleChange={(open) => {
        if (open) {
          handleSearch('');
        }
      }}
    />
  );
};
export default OmniChannelCustomerSelect;
